module.exports = __webpack_public_path__ + "img/care-retouching-rtw.76cfe8fc.png";